import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import Element from "../Form/Element";
import styles from "./style.module.css";
const Checkbox = forwardRef(({ type = 'checkbox', hiddenContainer = true, placeholder, ...props }, ref) => {
    return (_jsx(Element, { ...props, hiddenContainer: hiddenContainer, children: (props) => _jsxs("div", { className: 'ui-checkbox-container ' + styles['container'], children: [_jsx("input", { ...props, className: 'ui-checkbox' + (props.className ? ' ' + props.className : ''), type: type, ref: ref }), _jsx("span", { className: 'ui-checkbox-indicator ' + styles['indicator'] }), _jsx("span", { className: 'ui-checkbox-text ' + styles['text'], children: placeholder })] }) }));
});
export default Checkbox;
